import axios from 'axios';
import { VIDEO_OBS_URL } from 'constants/routes';

const axiosConfig = axios.create({
  baseURL: VIDEO_OBS_URL,
  withCredentials: true
});

export default axiosConfig;
